import { cn as e } from "../utils/index.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
import { Slot as r } from "@radix-ui/react-slot";
//#region src/components/tooltip.tsx
function i({ className: t, children: r, ...i }) {
	return /* @__PURE__ */ n("div", {
		"data-slot": "tooltip",
		className: e("absolute bottom-full left-1/2 -translate-x-1/2 mb-3 hidden group-hover/tooltip:block z-10 pointer-events-none", t),
		...i,
		children: /* @__PURE__ */ n("div", {
			className: "bg-white rounded-md shadow-lg border border-(--neutral-100) px-3 py-2 whitespace-nowrap",
			children: r
		})
	});
}
function a({ className: t, ...r }) {
	return /* @__PURE__ */ n("div", {
		"data-slot": "tooltip-header",
		className: e("font-md-12 text-(--neutral-700) text-left", t),
		...r
	});
}
function o({ className: t, ...r }) {
	return /* @__PURE__ */ n("div", {
		"data-slot": "tooltip-body",
		className: e("flex items-center gap-1.5 mt-1", t),
		...r
	});
}
function s({ ...i }) {
	let [a, o] = t.useState(!1);
	return /* @__PURE__ */ n(r, {
		className: e(a ? "group/tooltip" : ""),
		onMouseEnter: () => o(!0),
		onMouseLeave: () => o(!1),
		...i
	});
}
//#endregion
export { i as Tooltip, o as TooltipBody, a as TooltipHeader, s as TooltipTrigger };
